import React from "react";
import axios from "@/utils/myaxios";
import moment from "moment";
import Cookie from "js-cookie";
import { Link } from "react-router-dom";
import { tableSummaries, isMobileDevice } from "@/utils/utils";
import {
    Button,
    Table,
    Empty,
    Select,
    Collapse,
    Tag,
    Row,
    Col,
    Modal,
    InputNumber,
    Pagination,
    Spin,
} from "antd";
import HandDetail from "@/pages/commom/HandDetail";
import HandDetailOfc from "@/pages/commom/HandDetailOfc";

export default class PartnerCardQuery extends React.Component {
    state = {
        type: undefined, // 弹窗类型
        title: undefined, // 弹窗标题
        show: false, // 是否显示手牌弹窗
        loading: false, // 是否加载中
        handCardLoading: false, // 手牌记录是否加载中
        queryParams: {
            // 查询参数
            uid1: undefined,
            uid2: undefined,
            page: 1,
            limit: 20,
        },
        handCardQueryParams: {
            // 手牌记录查询参数
            page: 1,
            limit: 10,
            total: 0,
        },
        data: [], // 表格数据
        selectedData: {}, // 选中的表格数据
        handCardDataList: [], // 手牌数据
    };

    componentDidMount () {
        this.fetchData();
    }

    /**
     * 获取数据
     */
    fetchData = () => {
        this.setState({ loading: true });
        axios
            .get("/v1/api/partner/suspicious_partner_card_list", {
                params: {
                    ...this.state.queryParams,
                },
            })
            .then((res) => {
                this.setState({
                    loading: false,
                    queryParams: { ...this.state.queryParams },
                    data: res.data || [],
                });
            });
    };

    /**
     * 获取手牌记录数据
     */
    fetchHandCardData = () => {
        this.setState({ handCardLoading: true });
        axios
            .get("/v1/api/partner/suspicious_partner_hand_list", {
                params: {
                    ...this.state.handCardQueryParams,
                    uid1: this.state.selectedData.uid1,
                    uid2: this.state.selectedData.uid2,
                    total: undefined,
                },
            })
            .then((res) => {
                this.setState({
                    show: true,
                    handCardLoading: false,
                    handCardQueryParams: {
                        ...this.state.handCardQueryParams,
                        total: res.count || 0,
                    },
                    handCardDataList: res.data || [],
                });
            });
    };

    /**
     * 显示弹窗
     */
    handleShow = (type, item) => {
        if (type === "handCard") {
            // 可疑牌局
            this.setState(
                {
                    type,
                    show: true,
                    title: this.props.language["dubiousGamble"],
                    selectedData: item,
                    handCardDataList: [],
                    handCardQueryParams: {
                        ...this.state.handCardQueryParams,
                        page: 1,
                    },
                },
                () => this.fetchHandCardData()
            );
        }
    };

    /**
     * 改变分页
     */
    hanldeChangePage = (pagination, type) => {
        if (type === "handCard") {
            // 可疑牌局
            this.setState(
                {
                    handCardQueryParams: {
                        ...this.state.handCardQueryParams,
                        page: pagination.current,
                    },
                },
                () => this.fetchHandCardData()
            );
        } else {
            this.setState(
                {
                    queryParams: {
                        ...this.state.queryParams,
                        page: pagination.current,
                        limit: pagination.pageSize,
                    },
                },
                () => this.fetchData()
            );
        }
    };

    /**
     * 设置查询数据
     */
    handleSetQueryParamsData = (key, value, type) => {
        if (type === "data") {
            // 表格数据
            this.setState({
                queryParams: { ...this.state.queryParams, page: 1, [key]: value },
            });
        }
    };

    /**
     * 重置
     */
    handleReset = () => {
        // 表格数据
        this.setState(
            {
                queryParams: {
                    uid1: undefined,
                    uid2: undefined,
                    page: 1,
                    limit: 20,
                },
                data: [],
            },
            () => {
                this.fetchData();
            }
        );
    };

    render () {
        return (
            <div className="main-container">
                {/* 表头 */}
                <div className="container-header">
                    <InputNumber
                        precision={0}
                        min={0}
                        max={100000000}
                        placeholder={this.props.language["palyerOneIdPlaceholder"]}
                        value={this.state.queryParams.uid1}
                        onChange={(value) =>
                            this.handleSetQueryParamsData("uid1", value, "data")
                        }
                    />
                    <InputNumber
                        precision={0}
                        min={0}
                        max={100000000}
                        placeholder={this.props.language["playerTwoIdPlaceholder"]}
                        value={this.state.queryParams.uid2}
                        onChange={(value) =>
                            this.handleSetQueryParamsData("uid2", value, "data")
                        }
                    />
                    <Button
                        type="primary"
                        icon="search"
                        loading={this.state.loading}
                        onClick={this.fetchData}
                    >
                        {this.props.language["query"]}
                    </Button>
                    <Button type="default" icon="reload" onClick={this.handleReset}>
                        {this.props.language["reset"]}
                    </Button>
                </div>

                {/* 内容 */}
                <div className="container-content">
                    <Table
                        dataSource={this.state.data}
                        pagination={{
                            showTotal: (total) =>
                                `${this.props.language["total"]} ${total} ${this.props.language["item"]}`,
                            showQuickJumper: true,
                            showSizeChanger: true,
                            size: isMobileDevice() ? 'small' : '',
                            pageSizeOptions: ["10", "20", "30", "40"],
                            current: this.state.queryParams.page,
                            pageSize: this.state.queryParams.limit,
                            total: this.state.queryParams.total,
                        }}
                        loading={this.state.loading}
                        onChange={this.hanldeChangePage}
                        scroll={{ x: true }}
                        rowKey={(record, index) => index}
                    >
                        <Table.Column
                            align="center"
                            title={this.props.language["palyerOneId"]}
                            dataIndex="uid1"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["playerOneName"]}
                            dataIndex="name1"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["playerTwoId"]}
                            dataIndex="uid2"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["playerTwoName"]}
                            dataIndex="name2"
                        />
                        <Table.Column
                            align="center"
                            title="可疑牌局数量"
                            dataIndex="count"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["operation"]}
                            dataIndex=""
                            fixed={isMobileDevice() ? false : "right"}
                            width={140}
                            render={(item) => (
                                <Button
                                    type="default"
                                    loading={
                                        item.uid1 === this.state.selectedData.uid1 &&
                                        item.uid2 === this.state.selectedData.uid2 &&
                                        this.state.handCardLoading
                                    }
                                    onClick={() => this.handleShow("handCard", item)}
                                >
                                    {this.props.language["dubiousGamble"]}
                                </Button>
                            )}
                        />
                    </Table>
                </div>

                {/* 手牌记录弹窗 */}
                <HandCardModal
                    {...this.props}
                    visible={this.state.show}
                    type={this.state.type}
                    title={this.state.title}
                    loading={this.state.handCardLoading}
                    handCardQueryParams={this.state.handCardQueryParams}
                    pagination={{
                        showTotal: (total) =>
                            `${this.props.language["total"]} ${total} ${this.props.language["item"]}`,
                        showQuickJumper: true,
                        current: this.state.handCardQueryParams.page,
                        pageSize: this.state.handCardQueryParams.limit,
                        total: this.state.handCardQueryParams.total,
                        size: isMobileDevice() ? 'small' : '',
                    }}
                    handCardDataList={this.state.handCardDataList}
                    selectedData={this.state.selectedData}
                    searchPlayer={{
                        uid1: this.state.selectedData.uid1,
                        uid2: this.state.selectedData.uid2,
                    }}
                    onCancel={() => this.setState({ show: false })}
                    onChange={(pagination) =>
                        this.hanldeChangePage({ current: pagination }, "handCard")
                    }
                />
            </div>
        );
    }
}

/**
 * 手牌记录弹窗
 */
class HandCardModal extends React.Component {
    render () {
        let handCardTitle = (
            <Row type={isMobileDevice() ? '' : 'flex'} align='middle'>
                <Col>
                    <span className="mr10">{this.props.title}</span>
                </Col>
                <Col>
                    <Tag color="blue">
                        {this.props.language["palyerOneId"]}: {this.props.searchPlayer.uid1}
                    </Tag>
                    <Tag color="red">
                        {this.props.language["playerTwoId"]}: {this.props.searchPlayer.uid2}
                    </Tag>
                </Col>
            </Row>
        );

        return (
            <Modal
                maskClosable={false}
                width={1600}
                title={
                    this.props.type === "handCard" ? handCardTitle : this.props.title
                }
                visible={this.props.visible}
                onCancel={this.props.onCancel}
                centered={isMobileDevice()}
                bodyStyle={{
                    maxHeight: '70vh',
                    overflowY: "auto",
                }}
                footer={
                    <Pagination

                        showQuickJumper
                        {...this.props.pagination}
                        showTotal={(total) =>
                            `${this.props.language["total"]} ${total} ${this.props.language["item"]}`
                        }
                        size={isMobileDevice() ? 'small' : ''}
                        onChange={this.props.onChange}
                    />
                }
            >
                <div className="container-content">
                    {/* 手牌记录 */}
                    {this.props.type === "handCard" && (
                        <Spin spinning={this.props.loading}>
                            {/* 暂无数据 */}
                            {this.props.handCardDataList.length && (
                                <>
                                    <Collapse accordion>
                                        {this.props.handCardDataList.map((handCardData, index) => (
                                            <Collapse.Panel
                                                header={
                                                    <>
                                                        <span>Mid: {handCardData.mid}</span>
                                                        <span className="ml10">
                                                            {handCardData.detail.hand_time
                                                                ? handCardData.detail.hand_time
                                                                : ""}
                                                        </span>
                                                        <span className="ml10">
                                                            {handCardData.detail.hid}{this.props.language["hand"]}
                                                        </span>
                                                    </>
                                                }
                                                key={index}
                                            >
                                                {/* OFC */}
                                                {handCardData.kind === 6 && (
                                                    <HandDetailOfc
                                                        {...this.props}
                                                        handCardData={handCardData.detail}
                                                        searchPlayer={this.props.searchPlayer}
                                                    />
                                                )}

                                                {/* NLH, 6+, PLO, AOF, MTT */}
                                                {handCardData.kind !== 6 && (
                                                    <HandDetail
                                                        {...this.props}
                                                        handCardData={handCardData.detail}
                                                        squidConf={this.props.selectedData.squid_conf}
                                                        searchPlayer={this.props.searchPlayer}
                                                    />
                                                )}
                                            </Collapse.Panel>
                                        ))}
                                    </Collapse>
                                </>
                            )}

                            {/* 暂无数据 */}
                            {!this.props.handCardDataList.length && (
                                <>
                                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                                </>
                            )}
                        </Spin>
                    )}
                </div>
            </Modal>
        );
    }
}
